const TENANT_ID = 'tenantId';
const JWT_STORAGE_KEY = 'jwt_access_token';
const LAST_API_CALL = 'last_api_call';

export const getAccessTokenLS = () => localStorage.getItem(JWT_STORAGE_KEY) ?? '';
export const setAccessTokenLS = (token: string) => localStorage.setItem(JWT_STORAGE_KEY, token);
export const removeAccessTokenLS = () => localStorage.removeItem(JWT_STORAGE_KEY);

export const getTenantIdLS = () => localStorage.getItem(TENANT_ID) ?? '';
export const setTenantIdLS = (token: string) => localStorage.setItem(TENANT_ID, token);
export const removeTenantIdLS = () => localStorage.removeItem(TENANT_ID);

export const getLastApiCallLS = () => localStorage.getItem(LAST_API_CALL) ?? '';
export const setLastApiCallLS = (timestamp: string) => localStorage.setItem(LAST_API_CALL, timestamp);
export const removeLastApiCallLS = () => localStorage.removeItem(LAST_API_CALL);
